
import Vue from "vue";
import { Component } from "vue-property-decorator";
import news, { News as NewsType } from "@/store/news";

@Component
export default class News extends Vue {
  name = "News";

  get newses(): NewsType[] {
    return news;
  }

  href(news: NewsType): string | undefined {
    if (news.md) return `/news/${this.$en(news.title)}`;
    else if (news.href) return news.href;
  }
}
